export const offerTypes = [
  { field: 'item_popular', label: 'Popular Offer', color: '#527b38', tint: '#f0f5e9' },
  { field: 'item_special', label: 'Special Offer', color: '#2374ae', tint: '#edf5fc' },
  { field: 'item_offer_festival', label: 'Festival Offer', color: '#b67b13', tint: '#fcf5e7' },
  { field: 'item_instant_offer', label: 'Instant Offer', color: '#8744ae', tint: '#f6effb' },
  { field: 'item_new', label: 'New Item Offer', color: '#16818b', tint: '#edf8f8' },
];

export function parseOffers(value) {
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
}

// Stored timestamps without an offset are restaurant-local (Nepal) times.
export function offerTimestamp(value, end = false) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(value)) return null;
  let date = value.trim().replace(' ', 'T');
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) date += end ? 'T23:59:59' : 'T00:00:00';
  if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(date)) date += '+05:45';
  const timestamp = Date.parse(date);
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function getOfferStatus(offer, now) {
  const end = offerTimestamp(offer['end time'], true);
  const start = offerTimestamp(offer['start time']);
  if (end !== null && end < now) return 'Expired';
  if (start !== null && start > now) return 'Upcoming';
  return 'Active';
}

export function getItemPrice(value, now) {
  const prices = parseOffers(value);
  const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kathmandu', hour: '2-digit', hourCycle: 'h23' }).format(now));
  const price = prices.length > 1 && (hour < 6 || hour >= 18) ? prices[1] : prices[0];
  return price === null || price === undefined || price === '' || !Number.isFinite(Number(price)) ? null : Number(price);
}

export function getOfferPrice(item, offer, now) {
  if (getOfferStatus(offer, now) === 'Active' && offer.price !== undefined && offer.price !== null && offer.price !== '' && Number.isFinite(Number(offer.price))) {
    return Number(offer.price);
  }
  return getItemPrice(item.item_price, now);
}

export function buildOffers(items, now) {
  return items.flatMap((item, itemIndex) => offerTypes.flatMap((type) =>
    parseOffers(item[type.field]).filter((offer) => offer?.status === true).map((offer, index) => ({
      item, offer, type, status: getOfferStatus(offer, now),
      key: `${item.sid || item.item_id || itemIndex}-${type.field}-${index}`,
      price: getOfferPrice(item, offer, now),
    }))
  ));
}

export function getInstantOffers(items, now) {
  return buildOffers(items, now).filter(({ type }) => type.field === 'item_instant_offer');
}
